<kendo-dialog title="{{'_Shared_ModalPopUp_Impl_Stay_Title_Text_' | translate }}"  [minWidth]="300" [width]="500" (close)="close()">
  <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
  <p>{{'_General_Message_Unsaved_Changes_Info_Text_' | translate }}</p>

  <kendo-dialog-actions class="cc-btn-panel" class="cc-btn-panel">
    <button class="btn btn-secondary" (click)="stay()" >{{'_Shared_ModalPopUp_Impl_Stay_Text_' | translate }}</button>
    <button class="btn btn-primary"  primary="true" (click)="leave()">{{'_Shared_ModalPopUp_Impl_Leave_Text_' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>
